import type { TestMatchingFontSchemaType, TestMatchingSchemaType } from '@vedalib/editor/lib/brand'
import cn from 'classnames'
import React from 'react'

import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import type { ElementFontCss, ElementStyleCss } from 'services/Branding/types'
import { testProps } from 'utils/test/qaData'

// eslint-disable-next-line no-restricted-imports
import MatchingItemStyled from '../../../styled/MatchingItemStyled'
import * as s from './MatchingItem.module.scss'

type ItemProps = {
  isActive?: boolean
  isDropTarget?: boolean
  ariaLabel?: string
  tabIndex?: number
  mode: 'left' | 'right'
  isDragged?: boolean
  height?: number
  styles: ElementStyleCss<TestMatchingSchemaType>
  font: ElementFontCss<TestMatchingFontSchemaType>
  children: React.ReactNode
  index: number
}

const MatchingItem = React.forwardRef<HTMLDivElement, ItemProps>(
  (
    {
      isActive,
      isDropTarget,
      ariaLabel,
      tabIndex,
      mode,
      isDragged,
      styles,
      height,
      children,
      index,
      font,
    },
    ref,
  ) => {
    const isLeftItem = mode === 'left'

    const radiusStyles = isLeftItem
      ? {
          borderBottomLeftRadius: styles.pair.borderRadius,
          borderTopLeftRadius: styles.pair.borderRadius,
        }
      : {
          borderBottomRightRadius: styles.pair.borderRadius,
          borderTopRightRadius: styles.pair.borderRadius,
        }

    const rootStyles = {
      backgroundColor: styles.pair.backgroundColor,
      padding: styles.indents.padding,
      ...radiusStyles,
      ...styles.border,
      ...font?.base,
      height,
      opacity: isDragged ? 0.4 : 1,
      outline: isDropTarget ? '3px solid currentColor' : undefined,
    }

    return (
      <MatchingItemStyled
        $isActive={isActive}
        $isDragged={isDragged}
        $isLeft={isLeftItem}
        $styles={styles}
        aria-label={ariaLabel}
        id='itemWrapper'
        ref={ref}
        style={rootStyles}
        tabIndex={tabIndex}
      >
        <div className={cn(s.item)} id='itemContent'>
          {isLeftItem ? (
            <div
              style={{ marginRight: styles.indents.marginRight }}
              {...testProps({ el: 'courseMatchingDrag', index })}
            >
              {styles.icon.backgroundImage ? (
                <div className={s.icon} style={styles.icon} />
              ) : (
                <div className={s.burgerIcon} style={{ color: font.base.color }}>
                  <Icon name='otherBurger' size={KitSize.S} />
                </div>
              )}
            </div>
          ) : undefined}
          {children}
        </div>
      </MatchingItemStyled>
    )
  },
)

MatchingItem.displayName = 'MatchingItem'

export default MatchingItem
